<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['report_cards'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="row gap-2">
                  <!-- Filter controls remain the same -->
                  <b-form-group class="col-md-2 ps-0 pe-1" label="Class">
                    <v-select
                      :options="
                        schoolclasses.filter(
                          (schoolclass) => schoolclass.level == 2,
                        )
                      "
                      placeholder="Select Class"
                      v-model="schoolclass"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 ps-0 pe-1" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select"
                      v-model="year"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 ps-0 pe-1" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      @input="FilterExams"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3 px-1" label="Exam">
                    <v-select
                      :options="exams"
                      placeholder="Select Exam"
                      v-model="exam"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2 ps-0 pe-1" label="Filter by">
                    <select
                      class="form-control"
                      v-model="filterby"
                      @change="FilterBy"
                      aria-placeholder="All students"
                    >
                      <option value="1" selected>All students</option>
                      <option value="2">One student</option>
                    </select>
                  </b-form-group>
                  <b-form-group
                    class="col-md-4 ps-0 pe-1"
                    v-if="filterby == 2"
                    label="Student"
                  >
                    <v-select
                      :options="
                        students.filter(
                          (student) => student.class.id == schoolclass.id,
                        )
                      "
                      placeholder="Select Student"
                      v-model="student"
                      :reduce="(students) => students.student.student_id"
                      searchable
                    >
                      <template slot="option" slot-scope="option">
                        <div>
                          {{ option.student.first_name }}
                          {{ option.student.last_name }}
                          {{ option.class.name }} {{ option.stream.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div>
                          {{ option.student.first_name }}
                          {{ option.student.last_name }}
                          {{ option.class.name }} {{ option.stream.name }}
                        </div>
                      </template>
                    </v-select>
                  </b-form-group>
                  <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                </div>
              </div>

              <div v-if="exammarks.length > 0">
                <div class="text-center">
                  <router-link
                    :to="{
                      path: '/printnurseryreports',
                      query: {
                        term: schoolterm.id,
                        termname: schoolterm.name,
                        year: year,
                        class: schoolclass.id,
                        classname: schoolclass.name,
                        exam: exam.id,
                      },
                    }"
                    type="button"
                    class="btn-sm btn btn-primary"
                  >
                    <i class="mdi mdi-printer"></i> Print
                  </router-link>
                </div>

                <div v-for="item in exammarks" :key="item.id">
                  <div class="card">
                    <div
                      class="card-body"
                      style="font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
                    >
                      <div class="d-flex justify-content-between">
                        <div>
                          <span v-if="userData.logo != 0"
                            ><img
                              :src="getLogo(userData.logo)"
                              height="80"/><br
                          /></span>
                          <span v-else
                            ><img
                              src="@/assets/images/logo.png"
                              height="80"/></span
                          ><br />
                        </div>
                        <div></div>
                        <div>
                          <img
                            :src="getFiles(item.students.student_photo)"
                            height="80"
                          />
                        </div>
                      </div>

                      <div class="text-center">
                        <h5 style="color:black" class="text-uppercase mb-0">
                          {{ userData.school }}
                        </h5>
                        <span style="color:black;font-size:12px"
                          >Location : {{ userData.location }}</span
                        ><br />
                        <span style="color:black;font-size:12px"
                          >Telephone : {{ userData.contact }}</span
                        ><br /><br />
                        <span
                          style="color: black;font-size:18px"
                          class="text-uppercase text-decoration-underline"
                          ><b>{{ schoolterm.name }} PROGRESS REPORT</b></span
                        ><br />
                      </div>

                      <div class="d-flex justify-content-evenly">
                        <div class="text-uppercase" style="font-size: large;">
                          NAME : {{ item.students.first_name }}
                          {{ item.students.last_name }} <br />
                          CLASS : {{ schoolclass.name }}
                        </div>
                        <div class="text-uppercase" style="font-size: large;">
                          TERM : {{ schoolterm.name }} <br />
                          YEAR : {{ year }}
                        </div>
                      </div>

                      <!-- Subject & their details-->
                      <div class="row mt-3">
                        <div class="col-md-12 mx-auto">
                          <table class="table table-sm">
                            <thead>
                              <tr
                                class="text-uppercase text-align-center"
                                style="border-bottom: 2px solid black;"
                              >
                                <th>Learning Area</th>
                                <th>Expected Level</th>
                                <th>Child's Level</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr v-for="y in item.exams" :key="y.id">
                                <td>{{ y.subjects.name }}</td>
                                <td>{{ y.details[0].detail }}</td>
                                <!-- <td>{{y.mark[0].mark}}</td> -->
                                <td style="font-size: large;">
                                  <span v-if="y.mark[0].mark >= 96">A</span>
                                  <span
                                    v-if="
                                      y.mark[0].mark >= 80 &&
                                        y.mark[0].mark <= 95
                                    "
                                    >B</span
                                  >
                                  <span
                                    v-if="
                                      y.mark[0].mark >= 50 &&
                                        y.mark[0].mark <= 79
                                    "
                                    >C</span
                                  >
                                  <span
                                    v-if="
                                      y.mark[0].mark >= 30 &&
                                        y.mark[0].mark <= 49
                                    "
                                    >D</span
                                  >
                                  <span v-else-if="y.mark[0].mark <= 48"
                                    >E</span
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="d-flex justify-content-between mt-4">
                        <div class="teacher-comment">
                          <h5>Class Teacher's Comment:</h5>
                          <p class="signature-line">
                            ......................................................................................................................................
                          </p>
                          <p class="signature-line">
                            Signature:
                            ............................................................
                          </p>
                        </div>
                        <div class="headteacher-comment">
                          <h5>Head Teacher's Comment:</h5>
                          <p class="signature-line">
                            .......................................................................................................................................
                          </p>
                          <p class="signature-line">
                            Signature:
                            ............................................................
                          </p>
                        </div>
                      </div>

                      <br /><span
                        >Next Term Begins on :
                        <strong class="text-uppercase">
                          {{ date(userData.next_term) }}</strong
                        ></span
                      >

                      <div class="row mt-3">
                        <div class="col-md-10 mx-auto">
                          <div class="mt-4">
                            <h5><strong>KEY :</strong></h5>
                            <table class="table table-sm" border="3">
                              <!-- <tr v-for="x in item.grading" :key="x.id">
                                <td>{{ x.d1 }}</td>                                
                              </tr> -->
                              <tr>
                                <td>A</td>
                                <td>B</td>
                                <td>C</td>
                                <td>D</td>
                                <td>E</td>
                              </tr>
                              <tr>
                                <th>
                                  Excellent<br /><small>(95% - 100%)</small>
                                </th>
                                <th>
                                  Very Good<br /><small>(80% - 94%)</small>
                                </th>
                                <th>Good<br /><small>(50% - 79%)</small></th>
                                <th>Average<br /><small>(30% - 49%)</small></th>
                                <th>
                                  Needs Improvement<br /><small
                                    >(0% - 29%)</small
                                  >
                                </th>
                              </tr>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Report Cards.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Nursery Report Cards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Nursery Report Cards",
      items: [
        { text: "Dashboard", to: "/" },
        { text: " Nursery Report Cards", active: true },
      ],
      id: "",
      schoolsubjects: [],
      schoolsubject: "",
      schoolterm: "",
      schoolclass: "",
      exam: "",
      exams: [],
      year: new Date().getFullYear(),
      aggregates: "",
      exammarks: [],
      filterby: "1",
      student: "",
      student_id: "",
      nurserycomments: [],
    };
  },
  computed: {
    ...schooltermComputed,
    ...schoolclassComputed,
    ...studentComputed,
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.fetchSchoolClasses();
    this.fetchStudents();
    this.TotalRows = this.exammarks.length;
    this.isBusy = false;
  },

  methods: {
    ...schooltermMethods,
    ...schoolclassMethods,
    ...studentMethods,

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    Initials(speaker) {
      if (!speaker) return "";
      const name = speaker.split(" ");
      return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ""}`;
    },

    getLogo(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },

    async FilterExams() {
      let url = `/findschoolexam/${this.schoolterm.id},${this.year},${this.schoolclass.id}`;
      await axios.get(url).then((response) => {
        this.exams = response.data.exams;
      });
    },

    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "students/" + name;
      return imagelink;
    },

    FilterData() {
      let formData = new FormData();
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("schoolclass", this.schoolclass.id);
      formData.append("student_id", this.student);
      formData.append("exam", this.exam.id);

      let url = "/nurseryreportmarks";
      axios.post(url, formData).then((response) => {
        this.exammarks = response.data.marks;
      });

      // axios.get(`/nursery-comments/${this.schoolclass.id}`).then(response => {
      //   if (response.status == 200) {
      //     this.nurserycomments = response.data.nurserycomments;
      //   }
      // })
    },
    //     getCommentForAggregate(aggregate, nurserycomments, status) {
    //   const agg = parseInt(aggregate);
    //   for (let group of nurserycomments) {
    //     const start = parseInt(group.start_agg);
    //     const end = parseInt(group.end_agg);
    //     if ((group.status == status) && (agg >= start) && (agg <= end)) {
    //       return group.comment;
    //     }
    //   }
    //     return " - ";
    // },

    //     // CT & HT signature for specific status
    //     getSignatureForStatus(comment_groups, status) {
    //       if (!comment_groups || !Array.isArray(comment_groups) || comment_groups.length === 0) {
    //         return null;
    //       }
    //       const group = comment_groups.find(group => group.status === status && group.signature);

    //       if (group && group.signature) {
    //         let url = axios.defaults.baseURL;
    //         let imagelink = (url).slice(0, -3) + "signatures/" + group.signature;
    //         return imagelink;
    //       }
    //       return null;
    //     },

    date(dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "long" });
      const year = date.getFullYear();

      const getDaySuffix = (day) => {
        if (day >= 11 && day <= 13) return `${day}th`;
        switch (day % 10) {
          case 1:
            return `${day}st`;
          case 2:
            return `${day}nd`;
          case 3:
            return `${day}rd`;
          default:
            return `${day}th`;
        }
      };
      return `${getDaySuffix(day)} ${month} ${year}`;
    },

    FilterBy() {},
  },
};
</script>

<style>
table,
th,
td {
  border: 1px solid black;
  padding: 5px;
  border-collapse: collapse;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.font-weight-bold {
  font-weight: bold !important;
}
</style>
